import { useCallback, useContext, useState } from "react";

import { AppContext } from "../../../core/context/appContextProvider";
import { useEffectAsync } from "../../../utils/hooks/useEffectAsync.hook";
import { Client, ClientList } from "../../../utils/types/client.type";
import { getClients } from "../../client.service.v2";

export const useClientsEffect = () => {
  const [clients, setClients] = useState<ClientList | undefined>();
  const [loading, setLoading] = useState(false);
  const { informationAlert } = useContext(AppContext);

  const fetchClients = useCallback( async (isCanceled?: () => boolean) => {
    try {
      setLoading(true);
      const response = await getClients();

      if (isCanceled?.()) return;

      setClients(response);
      setLoading(false);
    } catch (e) {
      informationAlert("Error in getting clients", "error");
      setLoading(false);
    }
  }, []);

  useEffectAsync(async (isCanceled) => {
    await fetchClients(isCanceled);
  }, []);

  const updateClients = (updatedClients: Client[]) => {
    setClients((prevState) => ({
      ...(prevState ? prevState : {}),
      items: updatedClients
    }));
  };

  return {
    clients: clients?.items ?? [],
    fetchClients,
    loading,
    updateClients
  };
};
